/**
 * The MouseCursor class is an enumeration of constant values used in setting the cursor property of the Mouse class.
 * In HTML5 the const will be used as part of css class name to change the cursor. Used for `Mouse.registerCursor` and
 * `Mouse.showCustomCursor` as `name` params
 */
export class MouseCursor {
    /**
     * `auto`
     */
    public static AUTO: string = "auto";
    /**
     * `arrow`
     */
    public static ARROW: string = "arrow";
    /**
     * `hand`
     */
    public static HAND: string = "hand";
    /**
     * `click`
     */
    public static CLICK: string = "click";
    /**
     * `click`
     */
    public static DRAG: string = "drag";
}

// via https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
export enum CSSMouseCursor {
    AUTO = "auto",
    TEXT = "text",
    NONE = "none"
}
